import React from 'react'
import { Popover as ReactStrapPopover, PopoverProps as ReactStrapPopoverProps } from 'reactstrap'

import './Popover.scss'

export const Popover = (props: ReactStrapPopoverProps) => <ReactStrapPopover {...props} />
